export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/new-york-city-ef179cdee55fdfea4dd59b401b23a904.jpg";